import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Поиск ООПТ
  search (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/public/oopt/search/?${filter}`)
  },
  // Получение данных для поиска ООПТ
  getOoptData () {
    return axios.get(`${i18n.locale}/api/public/oopt/data`)
  },
  // Получение данных для отображения ООПТ
  getOoptView (id) {
    return axios.get(`${i18n.locale}/api/public/oopt/view/${id}`)
  },
  // Получение данных для формы создания ООПТ
  getOoptCreateFormData (type) {
    return axios.get(`${i18n.locale}/api/oopt/ooptCreateFormData/${type}`)
  },
  // Создание ООПТ
  createOopt (type, data) {
    return axios.post(`${i18n.locale}/api/oopt/create/${type}`, data)
  },
  // Получение данных для формы редактирования ООПТ
  getOoptEditFormData (id, type) {
    return axios.get(`${i18n.locale}/api/oopt/ooptEditFormData/${id}/${type}`)
  },
  // Создание "Трансграничное взаимодействие"
  createCrossBorder (id, data) {
    return axios.post(`${i18n.locale}/api/crossBorderInteraction/create/${id}`, data)
  },
  // Удаление "Трансграничное взаимодействие"
  deleteCrossBorder (id) {
    return axios.delete(
      `${i18n.locale}/api/crossBorderInteraction/delete/${id}`
    )
  },
  // Создание группы ООПТ
  createOoptGroup (data) {
    return axios.post(`${i18n.locale}/api/oopt_group/create`, data)
  },
  // Обновление ООПТ
  updateOopt (id, type, data) {
    return axios.patch(`${i18n.locale}/api/oopt/edit/${id}/${type}`, data)
  },
  // Мои организации
  getMyOopt (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/oopt/list/?${filter}`)
  },
  // данные для формы поиска
  searchFormData () {
    return axios.get(`${i18n.locale}/api/oopt/searchFormData`)
  },
  // Изменение статуса ООПТ
  publicOopt (ooptId, status) {
    return axios.get(`${i18n.locale}/api/oopt/${ooptId}/public/${status}`)
  }
}
